import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed, defineAsyncComponent } from 'vue';
import { userConfigStore } from '@/store';
import { BankAct } from '@tencent/wphk-act-base-components';
import { windowHelper } from '@tencent/ppd-base-libs';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from '@/components/content-loader.vue';
import SlotContentLoader from '@/components/slot-content-loader.vue';
import { BusinessType } from '@/types';

// 定义不同业务用于展示的组件

export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const components = {
  [BusinessType.visa]: () => import('../../components/custom/visa-custom.vue'),
  [BusinessType.dbs]: () => import('../../components/dbs-custom/index.vue'),
  [BusinessType.aeonStampRewards2023]: () => import('../../components/stamp-coupon/index.vue'),
};

// store
const { config } = toRefs(userConfigStore());
const isReady = computed(() => config.value.business);

// 动态组件
const asyncComponent = computed(() => {
  const { business } = config.value;
  if (components[business]) {
    return defineAsyncComponent({
      loader: () => components[business](),
      // 加载异步组件时使用的组件
      loadingComponent: SlotContentLoader,
      // 展示加载组件前的延迟时间，默认为 200ms
      delay: 200,
    });
  }
});

/** 跳转 tnc */
const toTnc = () => {
  if (config.value.tncInfo) {
    windowHelper.redirect(config.value.tncInfo, 200);
  }
};

return { __sfc: true,components, config, isReady, asyncComponent, toTnc, BankAct, BaseComponent, ContentLoader }
}

})